<template>
  <div class="pg-performer-events--loader">Loading...</div>
</template>

<script>
import consts from '../utils/consts'

export default {
  props: {
  },
  data() {
    return {
    }
  },
  created(){
  },
  computed:{
  },
  methods: {
  },
}
</script>


<style scoped>
  @import '../packs/application.css';

</style>
